export const pageUrlService = {
  getViewCheckpointPageUrl: (orgUnitId, appraisalId, checkPointId) =>
    `/check-points/${orgUnitId}/view-check-point/${appraisalId}/${checkPointId}`,

  getAggregateAppraisalReportPageUrl: orgUnitId =>
    `/data-reports/organization-reports/unit-reports/${orgUnitId}#aggregate-appraisal-report`,

  getDeltaPerformanceReportPageUrl: orgUnitId =>
    `/data-reports/organization-reports/unit-reports/${orgUnitId}#delta-performance-report`,

  getDetailedAppraisalReportPageUrl: orgUnitId =>
    `/data-reports/organization-reports/unit-reports/${orgUnitId}#detailed-appraisal-report`,

  getViewCheckpointReappraisalRationaleUrl: checkPointId =>
    `/reappraisal-rationale/${checkPointId}`,

  getEditEventPageUrl: eventId => `/calendar/edit-event/${eventId}`,

  getChangeDateRequestReviewPageUrl: requestId => `/date-change-review/${requestId}`,

  getObservationReportPageUrl: (eventId, observedUserId) =>
    `/observation-report/${eventId}/${observedUserId}`,

  getObservationReportReviewPageUrl: observationReportId =>
    `/observation-report/${observationReportId}`
};
